import { FinancialSituation, Mitigant, PaymentIssues } from '@lendi/core-constants';

export {
  Mitigant as MITIGANT_FACTOR,
  PaymentIssues as PAYMENT_ISSUES_TYPE,
  FinancialSituation as SIGNIFICANT_CHANGES_TYPE,
};

export type FINANCIAL_SITUATION_TYPE = Mitigant & PaymentIssues & FinancialSituation;

export const SIGNIFICANT_CHANGES_LABELS = {
  [FinancialSituation.None]: 'No expected changes',
  [FinancialSituation.ExtendedUnpaidLeave]: 'Extended unpaid leave (e.g. parental leave)',
  [FinancialSituation.TemporaryDecreaseInIncome]: 'Temporary reduction of income (e.g. end of employment contract)',
  [FinancialSituation.PermanentDecreaseInIncome]:
    'Permanent reduction of income (e.g. changing from full time to part time or leaving employment)',
  [FinancialSituation.LargeExpenditure]: 'Large expenditure',
  [FinancialSituation.IncreasedDebtRepaymentForExistingLoan]: 'Increased debt repayment for an existing loan',
  [FinancialSituation.MedicalTreatmentOrIllness]: 'Medical treatment or illness',
  [FinancialSituation.TemporaryIncreaseInExpense]: 'Relocation (e.g. moved to a new area)',
  [FinancialSituation.Other]: 'Other',
};

export const MITIGANT_LABELS: { [key: string]: string } = {
  [Mitigant.UsingSavings]: 'Use savings',
  [Mitigant.SecuringAdditionalIncome]: 'Use additional income source',
  [Mitigant.ReduceExpenditure]: 'Reduce expenses',
  [Mitigant.SaleOfAssets]: 'Sell assets',
  [Mitigant.CoApplicantsIncome]: "Rely on co-applicant's income",
  [Mitigant.ApplicationReflectsChanges]: 'Current lifestyle has already been adapted for future change',
  [Mitigant.Other]: 'Other',
};

export const PAYMENT_ISSUES_LABELS: { [key: string]: string } = {
  [PaymentIssues.None]: 'None of the following',
  [PaymentIssues.MissedPayments]: 'Missed payments',
  [PaymentIssues.OutstandingArrears]: 'Outstanding arrears',
  [PaymentIssues.LatePayments]: 'Late payments',
  [PaymentIssues.HardshipArrangements]: 'Hardship arrangements',
};
